import Layout from '@/layout/index.vue'

export const UserNotificationsRoute = {
  path: '/user-notifications',
  component: Layout,
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import(
          '@/features/user-notifications/views/index.vue'),
      name: 'UserNotificationsRoute',
      meta: {
        title: 'UserNotificationsRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
